// extracted by mini-css-extract-plugin
export var adjacentSlide = "_nc-9";
export var arrowButtonContainer = "_nc-5";
export var arrowButtonIcon = "_nc-6";
export var carouselArrowButton = "_nc-2";
export var carouselElementContainer = "_nc-1";
export var currentSlide = "_nc-8";
export var left = "_nc-3";
export var otherSlide = "_nc-a";
export var productCarouselContainer = "_nc-0";
export var right = "_nc-4";
export var sliderOverflow = "_nc-7";